import {cargoApiURL, externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import {X_B2B_CLIENT_ID} from '../consts'
import type {CargoCorpRepository, CargoCorpRepositoryParams, EmployeeCardToBoundListResponse} from './types'
import {withCargoCorpClient} from './utils'

// FIXME не понятно как описать этот репозиторий правильно. Лучше не писать сюда код и консультироваться с @yakovenkovv
export function createCargoCorpRepository(params: CargoCorpRepositoryParams): CargoCorpRepository {
  const {fetch} = params

  return {
    fetchLaunch() {
      throw new Error('Function "fetchLaunch" not implemented.')
    },
    fetchCountryInfo() {
      throw new Error('Function "fetchCountryInfo" not implemented.')
    },
    fetchEmployeeCardToBoundList(query) {
      return fetch<never, EmployeeCardToBoundListResponse, EmployeeCardToBoundListResponse>({
        method: 'post',
        url: addQuery(externalApiURL(withCargoCorpClient('employee/card-to-bound/list')), query),
      })
    },
    fetchEmployeeCardBound(clientID, body, query) {
      return fetch({
        method: 'post',
        url: addQuery(externalApiURL(withCargoCorpClient('employee/card/bound')), query),
        body,
        headers: {
          [X_B2B_CLIENT_ID]: clientID,
        },
      })
    },
    fetchEmployeePermissionList() {
      throw new Error('Function "fetchEmployeePermissionList" not implemented.')
    },
    fetchPaymentMethodInfo() {
      throw new Error('Function "fetchPaymentMethodInfo" not implemented.')
    },
    fetchPaymentMethodSelect(clientID, body) {
      return fetch({
        method: 'post',
        url: cargoApiURL(withCargoCorpClient('employee/payment-method/select')),
        body,
        headers: {
          [X_B2B_CLIENT_ID]: clientID,
        },
      })
    },
    fetchCardList(body, query) {
      return fetch({
        method: 'post',
        url: addQuery(externalApiURL(withCargoCorpClient('card/list')), query),
        body,
      })
    },
    fetchCardBoundContext(body, query) {
      return fetch({
        url: addQuery(externalApiURL(withCargoCorpClient('employee/card/bound/context')), query),
        method: 'post',
        body,
      })
    },
    fetchClientInfo() {
      return fetch({
        url: externalApiURL(withCargoCorpClient('client/info')),
        method: 'get',
      })
    },
    fetchNotificationsAgreements() {
      return fetch({
        url: externalApiURL(withCargoCorpClient('notifications-agreements')),
        method: 'get',
      })
    },
    fetchCreatePdfInvoice() {
      throw new Error('Function "fetchCreatePdfInvoice" not implemented.')
    },
    fetchDocumentList() {
      throw new Error('Function "fetchDocumentList" not implemented.')
    },
    fetchEmployeeCandidateList() {
      throw new Error('Function "fetchEmployeeCandidateList" not implemented.')
    },
    fetchEmployeeCandidateRemove() {
      throw new Error('Function "fetchEmployeeCandidateRemove" not implemented.')
    },
    fetchEmployeeCandidateUpsert() {
      throw new Error('Function "fetchEmployeeCandidateUpsert" not implemented.')
    },
    fetchEmployeeEdit() {
      throw new Error('Function "fetchEmployeeEdit" not implemented.')
    },
    fetchEmployeeList() {
      throw new Error('Function "fetchEmployeeList" not implemented.')
    },
    fetchEmployeeRemove() {
      throw new Error('Function "fetchEmployeeRemove" not implemented.')
    },
    fetchEmployeeRolesUpdate() {
      throw new Error('Function "fetchEmployeeRolesUpdate" not implemented.')
    },
    fetchStatsEmployees() {
      throw new Error('Function "fetchStatsEmployees" not implemented.')
    },
    fetchEditDetails() {
      throw new Error('Function "fetchEditDetails" not implemented.')
    },
    fetchBatchCreateTemplate() {
      throw new Error('Function "fetchBatchCreateTemplate" not implemented.')
    },
    fetchClientOptionsInfo() {
      throw new Error('Function "fetchClientOptionsInfo" not implemented.')
    },
    fetchClientOptionsEdit() {
      throw new Error('Function "fetchClientOptionsEdit" not implemented.')
    },
    fetchClientRobotTokenInfo() {
      throw new Error('Function "fetchClientOptionsEdit" not implemented.')
    },
    fetchClientRobotTokenEdit() {
      throw new Error('Function "fetchClientOptionsEdit" not implemented.')
    },
    fetchSuggestInn() {
      throw new Error('Function "fetchSuggestInn" not implemented.')
    },
    fetchOrderAvailability() {
      throw new Error('Function "fetchOrderAvailability" not implemented.')
    },
    fetchDocumentsUrls() {
    throw new Error('Function "fetchDocumentsUrls" not implemented.')
  },
  }
}
